export const isEnum = <T extends string>(
    value: string | undefined | null,
    enumToCheck: Record<string, T>,
): value is T => {
    if (value === undefined || value === null) {
        return false;
    }
    return Object.values(enumToCheck).includes(value as T);
};
